import { serviceConfig } from '../../config';
import { axiosInstance } from '../../services/shared';
import { AxiosResponse } from 'axios';
import { ColabQuery, ColabRecords, GetColab } from './types';

async function getColabs(query: ColabQuery) {
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.colab}/records`;
  let records;

  try {
    const response: AxiosResponse<ColabRecords> = await axiosInstance.get(url, { params: cleanQuery(query) });
    records = response?.data?.entities;
    records.sort((a: GetColab, b: GetColab) => b.created.localeCompare(a.created));
    return response.data;
  } catch (error) {
    console.error('Error fetching colab records:', error);
    throw error;
  }
}

function cleanQuery(query: ColabQuery) {
  const params: Record<string, string | string[] | number> = {};

  Object.entries(query).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length === 0) return;
    if (value === undefined || value === null || value === '') return;

    params[key] = value;
  });

  return params;
}

export { getColabs };
